module.exports = __webpack_public_path__ + "img/asc_def.0e042b5.png";